import UniversalRouter, { RouteParams, Routes } from 'universal-router';

import { Page } from './Page';

import { ProductPage } from './product';
import { ViewPage } from './view';
import { IntranetPage } from './intranet';
import { StorePage } from './store';
import { TermPage } from './term';
import { BlogPage } from './blog';
import { HomePage } from './home';

type Result = {
    params: RouteParams,
    page: Page
};

const children: Routes<Result> = [
    {
        path: [
            '/guantes-de-trabajo/:gloves',
            '/working-gloves/:gloves',
            '/gants-de-travail/:gloves',
            '/luvas-de-trabalho/:gloves',
            '/ropa-de-trabajo/:gloves',
            '/clothes/:clothing',
            '/vetements/:clothing',
            '/roupa/:clothing',
            '/store/product(.*)'
        ],
        action: (ctx, params): Result => ({ params, page: ProductPage }),
    },
    {
        path: [
            '/node/21098',
            '/comparativa(.*)',
            '/guantes-para-trabajar',
            '/guantes-de-trabajo',
            '/guantes-de-trabajo(.*)',
            '/working-gloves',
            '/working-gloves(.*)',
            '/gants-de-travail',
            '/gants-de-travail(.*)',
            '/luvas-de-trabalho',
            '/luvas-de-trabalho(.*)',
            '/ropa-de-trabajo',
            '/ropa-de-trabajo(.*)',
            '/clothing',
            '/clothing(.*)',
            '/clothes(.*)',
            '/vetements',
            '/vetements(.*)',
            '/roupa',
            '/roupa(.*)',
            '/store/product(.*)'
        ],
        action: (ctx, params): Result => ({ params, page: ViewPage }),
    },

    {
        path: [
            '/intranet',
            '/intranet(.*)',
            '/user(.*)',
            '/users(.*)',
            '/admin/panel',
        ],
        action: (ctx, params): Result => ({ params, page: IntranetPage }),
    },

    {
        path: [
            '/store',
            '/store(.*)',
        ],
        action: (ctx, params): Result => ({ params, page: StorePage }),
    },

    {
        path: [
            '/taxonomy/term/:term',
            '/soluciones/:term',
            '/sectores/:term',
            '/en/industries/:term',
            '/fr/secteurs/:term',
            '/pt/setores/:term',
        ],
        action: (ctx, params): Result => ({ params, page: TermPage }),
    },

    {
        path: [
            '/blog',
            '/pt/blog',
            '/fr/blog',
            '/en/blog',
            '/blog(.*)',
            '/pt/blog(.*)',
            '/fr/blog(.*)',
            '/en/blog(.*)'
        ],
        action: (ctx, params): Result => ({ params, page: BlogPage }),
    },

    {
        path: [
            '/',
            '/pt',
            '/fr',
            '/en',
        ],
        action: (ctx, params): Result => ({ params, page: HomePage }),
    },
];

const routes: Routes<Result> = [
    { path: '', children },
    { path: '/:lang?', children },
];

export const router = new UniversalRouter<Result>(routes);
